function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_8226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77212 13.6157L0.46165 11.4628C-0.476457 11.0825 -0.458851 9.74818 0.488964 9.39275L14.3896 4.18001C15.2828 3.84506 16.155 4.71731 15.8201 5.61052L10.6074 19.5111C10.2519 20.459 8.91759 20.4766 8.53728 19.5385L6.38438 14.228C6.27149 13.9495 6.05061 13.7286 5.77212 13.6157Z",
    fill: "#002CFB",
    style: {
      fill: "#002CFB",
      fill: "color(display-p3 0.0000 0.1725 0.9843)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_8226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendFilled);
export default __webpack_public_path__ + "static/media/iconSendFilled.4bfad0c4bec7340c35ab7a8dcf4c00b0.svg";
export { ForwardRef as ReactComponent };